import { styled } from 'next-yak';

export const Image = styled.img`
  height: auto;
  max-width: 100%;
`;
